import { Flame } from "lucide-react";

/**
 * StreakBadge — small pill showing consecutive-days streak.
 * Renders nothing when count is 0 (so it doesn't shout at empty sites).
 */
export function StreakBadge({ days = 0, best = 0, size = "md", testid = "streak-badge" }) {
    if (!days || days < 1) return null;
    const isBig = days >= 7;
    const cls = size === "sm"
        ? "text-[10px] px-1.5 py-0.5"
        : "text-xs px-2 py-1";
    const tone = isBig
        ? "bg-gradient-to-r from-amber-100 to-orange-100 text-orange-700 border-orange-200"
        : "bg-amber-50 text-amber-800 border-amber-200";
    return (
        <span
            className={`inline-flex items-center gap-1 rounded-full border font-semibold ${cls} ${tone}`}
            title={best ? `Best streak: ${best} days` : undefined}
            data-testid={testid}
        >
            <Flame className={size === "sm" ? "w-3 h-3" : "w-3.5 h-3.5"} strokeWidth={2.5} />
            {days}-day streak
        </span>
    );
}

export default StreakBadge;
